import { isAnyOf } from "@reduxjs/toolkit";

export const handleLoadingAndErrorState = (builder, thunks) => {
  builder
    .addMatcher(isAnyOf(...thunks.map((t) => t.rejected)), (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addMatcher(isAnyOf(...thunks.map((t) => t.pending)), (state, _) => {
      state.isLoading = true;
      state.error = null;
    })
    .addMatcher(isAnyOf(...thunks.map((t) => t.fulfilled)), (state, _) => {
      state.isLoading = false;
    });
};
